import StoreDetail from "./StoreDetail";

export default StoreDetail;
